import React from 'react';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType } from 'constants/enums/insType.enum';
import PolicyInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyInfo';
import BuildingInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/BuildingInfo';
import InsuredContent from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredContent';
import PolicyholderInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyholderInfo';
import InsuredInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredInfo';
import PaymentInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PaymentInfo';
import MortgageInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/MortgageInfo';
import { IProps, IState } from './types';
import _ from 'lodash';
import { ApplicantFirePropContent, InsuredDataFirePropContent } from 'bff/models/member';
import { RouterSettings } from 'constants/models/routerSettings';
import commonService from 'utils/commonService';
import { connect } from 'react-redux';
import { RootReducersState } from 'redux/reducers';

class PolicyDetailFire extends React.Component<IProps, IState> {
  state: IState = {
    detailInfo: {
      POLICY_DATA: {
        BC_TYPE: '',
        APPLY_TIME: '',
        INS_TYPE_ID: '',
        APPLY_NO: '',
        POLICY_NO: '',
        POLICY_STATUS: '',
        CONFLICT_STATUS: '',
        PAYMENT_STATUS: '',
        PROGRAM_ID: '',
        PHONE_SURVEY: '',
        DEPARTMENT: '',
        OPERATOR: '',
        POLICY_DELIVERY: ''
      },
      PHONE_SURVEY_DETAILS: new Array(0),
      BUILDING_INFO: {
        POSTCODE: '',
        CITY_ID: '',
        CITY_NAME: '',
        AREA_ID: '',
        AREA_NAME: '',
        ADDRESS_RD_ST: '',
        ADDRESS_LN: 0,
        ADDRESS_ALY: 0,
        ADDRESS_NO: 0,
        ADDRESS_F: 0,
        ADDRESS_FULL: '',
        BUILDING_FLOOR: 0,
        BUILDING_BASEMENT: 0,
        BUILDING_OUTLINE: '',
        USAGE_AREA: 0,
        BUILDING_STRUCTURE: '',
        ROOF_STRUCTURE: '',
        BUILDING_YEAR: ''
      },
      POLICY_INFO: {
        START_DATE: '',
        START_HOUR: '',
        END_DATE: '',
        INSURANCE_PERIOD: '',
        SUM_FEE: 0,
        SUM_FEE_TEXT: '',
        ITEMS: new Array(0)
      },
      APPLICANTS: new Array(0),
      INSUREDS: new Array(0),
      PAYMENT_DATA: {
        PAYMENT: '',
        PAY_EXPIRE: '',
        PAYER_NAME: '',
        PAYER_ID: '',
        CARD_NO: '',
        APPROVE_CODE: '',
        BANK_ID: '',
        BANK_NAME: '',
        BANK_ACCOUNT: '',
        TRANS_DATE: '',
        TRANS_TIME: '',
        AMOUNT: 0
      },
      MORTGAGE: {
        APPLY_NO: '',
        HDR_ID: '',
        HBRCH_ID: '',
        HBRCH_NAME: '',
        OPERATOR: '',
        POSTCODE: '',
        CITY_ID: '',
        AREA_ID: '',
        ADDRESS: '',
        ADDRESS_FULL: '',
        DELIVER_BANK: '',
        DELIVER_BANK_TEXT: ''
      },
      OPERATION_LOG: new Array(0),
      AVAILABLE_ACTION: {
        ACTIONS: new Array(0),
        ACTION_URL: ''
      }
    },
    insTypeId: ''
  }

  componentDidMount () {
    let detailInfoVal;
    let insTypeIdVal;
    if (this.props.history.location.state) {
      // 透過路由取得險種類別
      const { detailInfo, insTypeId }: any = this.props.history.location.state;
      detailInfoVal = detailInfo;
      insTypeIdVal = insTypeId;
    }
    // console.log('detailInfoVal', detailInfoVal);
    if (!detailInfoVal || !insTypeIdVal) {
      this.props.history.replace(RouterSettings.MemberCenter.PolicyInquiry);
      return;
    }

    this.setState({
      detailInfo: { ...detailInfoVal },
      insTypeId: insTypeIdVal
    });
  }

  render () {
    const { POLICY_INFO, BUILDING_INFO, POLICY_DATA, PAYMENT_DATA, APPLICANTS, INSUREDS, MORTGAGE } = this.state.detailInfo;

    return (
      <div className={`policy-detail policy-detail--${InsTypeDefinesEN[InsType.Fire]}`}>
        <div className="template-container">
          <div className="template-content">
            <div className="policy-detail__content">
              {/* 保單資訊 */}
              {
                POLICY_DATA && (
                  <PolicyInfo {...POLICY_DATA} INS_TYPE_ID={this.state.insTypeId} />
                )
              }
              {/* 建築物資料 */}
              {
                BUILDING_INFO && (
                  <BuildingInfo {...BUILDING_INFO} />
                )
              }
              {/* 投保內容 */}
              {
                POLICY_INFO && (
                  <InsuredContent collapsible>
                    <InsuredContent.List
                      INS_TYPE_ID={this.state.insTypeId}
                      INSURANCE_PERIOD={POLICY_INFO.INSURANCE_PERIOD}
                    />
                    <InsuredContent.Table
                      INS_TYPE_ID={this.state.insTypeId}
                      TOTAL_FEE={commonService.thousandFormat(`${POLICY_INFO.SUM_FEE}`)}
                      DATA={POLICY_INFO.ITEMS && [
                        {
                          CHILD_DATA: _.map(POLICY_INFO.ITEMS, (content: any) => {
                            return {
                              ITEM_NAME: content.ITEM_TITLE,
                              ITEM_AMT: content.ITEM_OPTION,
                              DISCOUNT_AMT: content.FEE
                            };
                          })
                        }
                      ]}
                    />
                  </InsuredContent>
                )
              }
              {/* 要保人資料 */}
              {
                APPLICANTS && APPLICANTS.length > 0 && (
                  <PolicyholderInfo
                    MULTI
                    APPLICANTS={_.map(APPLICANTS, (applicant: ApplicantFirePropContent) => {
                      return {
                        ...applicant,
                        ID: applicant.APPLICANT_ID,
                        NATIVE: applicant.APPLICANT_ID_TYPE_TEXT,
                        NAME: applicant.APPLICANT_NAME,
                        ADDRESS: `${applicant.POSTCODE}${applicant.CITY_NAME}${applicant.AREA_NAME}${applicant.ADDRESS}`
                      };
                    })}
                  />
                )
              }
              {/* 被保險人資料 */}
              {
                INSUREDS && (
                  <InsuredInfo
                    InsTypeId={this.state.insTypeId}
                    DATA={_.map(INSUREDS, (insured: InsuredDataFirePropContent, index: number) => {
                      return {
                        ...insured,
                        SEQNO: `${index + 1}`,
                        EMAIL_ADDR: insured.EMAIL,
                        ID: insured.INSURED_ID,
                        NAME: insured.INSURED_NAME,
                        RELATION: insured.RELATIONSHIP,
                        ADDRESS: `${insured.POSTCODE}${insured.CITY_NAME}${insured.AREA_NAME}${insured.ADDRESS}`
                      };
                    })}
                  />
                )
              }
              {/* 付款資訊 */}
              {
                PAYMENT_DATA && (
                  <PaymentInfo
                    {...PAYMENT_DATA}
                    PAY_BY={PAYMENT_DATA.PAYMENT}
                    BANK={PAYMENT_DATA.BANK_NAME}
                    TRANSACTION={PAYMENT_DATA.TRANS_DATE + PAYMENT_DATA.TRANS_TIME}
                    BANK_ACCOUNT={PAYMENT_DATA.BANK_ACCOUNT}
                  />
                )
              }
              {/* 抵押權資料 */}
              {
                MORTGAGE && (
                  <MortgageInfo {...MORTGAGE} />
                )
              }
            </div>
            <div className="policy-detail__controls">
              <button type="button" className="policy-detail__btn" onClick={() => this.props.history.push(RouterSettings.MemberCenter.PolicyInquiry)}>{commonService.getNameByLng(this.props.resources, 'TID_Back_to_policy_query')}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    resources: state.resources
  };
};

export default connect(mapStateToProps)(PolicyDetailFire);
